import { uzLatnToCyrl } from '../i18n/translit';
import type { BenchLab } from './schema';

/**
 * Bench lab ta'rifidagi barcha I18nText obyektlarga ("uz-Latn" kalitli) yetishmagan
 * uz-Cyrl matnini transliteratsiya orqali qo'shadi. Chuqur yurish — sxema o'zgarsa ham ishlaydi.
 */
function walk(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(walk);
  if (value && typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    if (typeof obj['uz-Latn'] === 'string') {
      return obj['uz-Cyrl'] !== undefined ? obj : { ...obj, 'uz-Cyrl': uzLatnToCyrl(obj['uz-Latn']) };
    }
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) out[k] = walk(v);
    return out;
  }
  return value;
}

export function fillCyrillicBench(lab: BenchLab): BenchLab {
  return walk(lab) as BenchLab;
}
